import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractTable } from '../../table.class';
import { Col } from '../../../../cols/col.class';
import { Checkbox } from '../../../../../../components/checkbox/checkbox.component';

@Component({
   selector: 'app-col-control',
   template: `
      <exi-checkbox [ctx]="visible" class="checkbox"></exi-checkbox>
      <exi-checkbox [ctx]="pinned" class="checkbox"></exi-checkbox>
      <div class="title">
         <span class="text-cutter"> {{ col.title() }}</span>
      </div>
   `,
   styleUrls: ['./col-control.component.scss']
})
export class ColControlComponent implements OnInit {
   @Input() col: Col<object>;
   @Input() ctx: AbstractTable<any>;
   @Output() onVisibility = new EventEmitter<boolean>();
   public visible: Checkbox<Col<object>>;
   public pinned: Checkbox<Col<object>>;


   constructor() { }

   ngOnInit() {
      this.visible = {
         type: 'EYE',
         toggle: () => {
            this.ctx.cols.toggleVisibility(this.col);
            this.onVisibility.emit(this.col.isVisible);
         },
         isSelected: () => this.col.isVisible,
         isDisabled: () => this.ctx.cols.visible.length === 1 && this.col.isVisible,
      };

      this.pinned = {
         type: 'PIN',
         toggle: () => {
            this.ctx.cols.togglePinned(this.col);
         },
         isSelected: () => this.col.isPinned,
      };


   }
}
